import { render, staticRenderFns } from "./bStore_setup_order.vue?vue&type=template&id=7ca3354f&scoped=true"
import script from "./bStore_setup_order.vue?vue&type=script&lang=js"
export * from "./bStore_setup_order.vue?vue&type=script&lang=js"
import style0 from "./bStore_setup_order.vue?vue&type=style&index=0&id=7ca3354f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca3354f",
  null
  
)

export default component.exports